import React from 'react'
import { IssuingUserStatus } from './issuingUserStatus'

export const IssuingModifyUserStatus = () => {
  return (
    <IssuingUserStatus />
  )
}
